import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import ScrollReveal from '../components/ScrollReveal';
import SEO from '../components/SEO';
import JsonLd from '../components/JsonLd';
import { faqData } from '../data/faqData';
import './Faq.css';

export default function Faq({ language }) {
  const isEN = language === 'en';

  const ui = isEN
    ? {
        title: 'Frequently asked questions',
        subtitle: 'Everything you need to know before starting your project with an architect in the Hérault.',
        ctaText: 'Have another question about your project?',
        ctaBtn: 'Contact DP Architecture',
        seoTitle: 'FAQ - Architect in Montpellier | DP Architecture',
        seoDescription:
          'Answers to frequently asked questions about DP Architecture: services, fees, regulations (RE2020), how a project unfolds and project types in Montpellier and the Hérault.'
      }
    : {
        title: 'Questions fréquentes',
        subtitle: "Tout ce qu'il faut savoir avant de lancer votre projet avec un architecte dans l'Hérault.",
        ctaText: 'Vous avez une autre question sur votre projet ?',
        ctaBtn: 'Contacter DP Architecture',
        seoTitle: 'FAQ - Architecte à Montpellier | DP Architecture',
        seoDescription:
          "Réponses aux questions fréquentes sur DP Architecture : services, honoraires, réglementation RE2020, déroulé d'un projet et types de réalisations à Montpellier et dans l'Hérault."
      };

  // JSON-LD FAQPage construit à partir du contenu RÉELLEMENT affiché (langue active)
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqData.flatMap((cat) =>
      cat.items.map((it) => ({
        '@type': 'Question',
        name: isEN ? it.qEN : it.q,
        acceptedAnswer: { '@type': 'Answer', text: isEN ? it.aEN : it.a }
      }))
    )
  };

  return (
    <div className="faq-page">
      <JsonLd data={faqSchema} />
      <SEO
        title={ui.seoTitle}
        description={ui.seoDescription}
        keywords="faq architecte montpellier, questions architecte hérault, honoraires architecte, recours architecte obligatoire, RE2020 maison, rénovation énergétique hérault"
      />

      <div className="page-container faq-container">
        <ScrollReveal>
          <h1 className="page-title page-mb">{ui.title}</h1>
          <p className="page-subtitle">{ui.subtitle}</p>
        </ScrollReveal>

        {faqData.map((cat, ci) => (
          <ScrollReveal key={ci} delay={0.05 * ci}>
            <section className="faq-category">
              <h2 className="faq-category-title">{isEN ? cat.categoryEN : cat.category}</h2>
              <div className="faq-list">
                {cat.items.map((it, ii) => (
                  <details className="faq-item" name={`faq-${ci}`} key={ii}>
                    <summary className="faq-question">{isEN ? it.qEN : it.q}</summary>
                    <div className="faq-answer">
                      <p>{isEN ? it.aEN : it.a}</p>
                    </div>
                  </details>
                ))}
              </div>
            </section>
          </ScrollReveal>
        ))}

        <ScrollReveal>
          <div className="faq-cta">
            <p>{ui.ctaText}</p>
            <Link to="/contact" className="faq-cta-btn">
              {ui.ctaBtn}
              <ArrowRight size={16} />
            </Link>
          </div>
        </ScrollReveal>
      </div>
    </div>
  );
}
